import { Alert } from '@economic/taco';
import { Trans } from '@lingui/macro';
import type { CompanyResponse } from '~/payment-cards-feature';
import { CompanySettingsButton } from './CompanySettingsButton';

export const DialogContentWithoutCVR = ({
    onSettingsSaved,
    currentCompanyData,
}: {
    onSettingsSaved: () => void;
    currentCompanyData: CompanyResponse;
}) => {
    return (
        <>
            <Alert state="error" className="mb-6">
                <Trans>
                    We were not able to find your company registration number (CVR or SE number). Please complete the field “Co.
                    reg. no.” in your company's settings.
                </Trans>
            </Alert>
            <div className="flex justify-end mt-2">
                <CompanySettingsButton onSettingsSaved={onSettingsSaved} currentCompanyData={currentCompanyData} />
            </div>
        </>
    );
};
